<script context="module">
	import { get } from 'svelte/store'
	// import { text_entered, preview_mode, previews_min_font_size, previews_max_font_size} from './../stores.js'

	export function setPreviewMode() {
		let current_mode = get(preview_mode)
		if (get(text_entered).length === 1) preview_mode.set('letters')
		if (get(text_entered).length > 1 && get(text_entered).length <= 55) preview_mode.set('words')
		if (get(text_entered).length > 55) preview_mode.set('paragraphs')
		if (current_mode !== get(preview_mode)) {
			console.log('Previews - preview mode set to ' + get(preview_mode))
		}
		setFontSizes()
	}

	function setFontSizes() {
		let current_min = get(previews_min_font_size)
		let current_max = get(previews_max_font_size)
		switch (get(preview_mode)) {
			case 'letters':
				previews_min_font_size.set(0)
				previews_max_font_size.set(12)
				break
			case 'words':
				previews_min_font_size.set(0)
				previews_max_font_size.set(10)
				break
			case 'paragraphs':
				previews_min_font_size.set(-3)
				previews_max_font_size.set(3)
				break
		}
		if (current_min !== get(previews_min_font_size) || current_max !== get(previews_max_font_size)) {
			console.log('Previews - adjusted min max font sizes: ' + get(previews_min_font_size) + "–" + get(previews_max_font_size))
		}
		if (get(previews_font_size) > get(previews_max_font_size)) previews_font_size.set(get(previews_max_font_size) - 1)
		if (get(previews_font_size) < get(previews_min_font_size)) previews_font_size.set(get(previews_min_font_size) + 1)
	}

</script>

<script>
	import { _ } from "svelte-i18n"
	import { 
		text_entered, text_previewed, text_caseapplied, selected_text_case, text_entered_once,
		preview_mode, previews_are_highlighted, previews_font_size, previews_max_font_size, previews_min_font_size, hero_expanded 
	} from './../stores.js'
	import { selectOnFocus, focusOnInit } from './../modules/helpers.js'
	import TextCaseSelect from './TextCaseSelect.svelte'
	import TextAreaHelper from './TextAreaHelper.svelte'
	import TextAreaStartButton from './TextAreaStartButton.svelte'
	
	let textareaEl
	let shiftDown = false

	function handleKeyup(event) {
		$text_entered = textareaEl.value
		$text_previewed = textareaEl.value
		$text_caseapplied = textareaEl.value
		$previews_are_highlighted = false			// reset highlighting
		$selected_text_case = undefined				// reset case selection
		setPreviewMode()
		if (event.key === 'Shift') {
			shiftDown = false
		}
	}

	function handleKeyDown(event) {
		if (event.key === 'Shift') {
			shiftDown = true
		}
		if (event.key === 'Enter' && !shiftDown && $text_entered !== '') {
			enterText()
		}
	}

	function enterText() {
		textareaEl.blur()
		$hero_expanded=false
		$text_entered_once = true
	}

</script>

<div 
	class="textarea-container"
	class:expanded={$hero_expanded} 
	class:text_entered_once>
	<textarea 
		bind:this={textareaEl} 
		on:keyup|preventDefault={handleKeyup}
		on:keydown={handleKeyDown}
		on:focus={() => $hero_expanded=true}
		use:selectOnFocus 
		use:focusOnInit 
		placeholder="{$_('textArea.placeholder')}" 
		autoComplete="off"
		spellcheck="false" 
		rows="1" 
		value="{$text_entered}"
	></textarea>
	<TextAreaStartButton on:click={enterText}/>
	<TextCaseSelect/>
	<TextAreaHelper/>
</div>

<style>
	.textarea-container {
		z-index: 4;
		display: inline-block;
		position: relative;
		width: fit-content;
	}
	.textarea-container.expanded {
		margin-top: 6rem;
	}
	div textarea {
		display: block;
		resize: none;
		width: 46rem;
		height: 4rem;
		padding: 0 10rem 0 1.4rem;
		white-space: pre-wrap;
		font-family: var(--PensumSans-Bold);
		font-size: 2.3rem;
		font-weight: 600;
		line-height: 3.6rem;
		color: var(--c-textfield-text);
		background-color: var(--c-textfield-bg);
		border: none;
		border-radius: 2rem;
		transition-property: width, height, border-radius, line-height, font-size, padding, margin-left, background-color;
		transition-duration: var(--transition-duration);
		transition-timing-function: var(--transition-function);
	}
	.textarea-container textarea::placeholder {
		color: var(--c-text-faded);
	}
	.textarea-container textarea:not(:focus):hover {
		background-color: var(--c-textfield-bg);
	}	
	.textarea-container.expanded textarea {
		width: 70rem;
		height: 9rem;
		margin-left: -3rem;
		padding: 0 0 0 3rem;
		font-size: 5.4rem;
		font-weight: 600;
		line-height: 8.2rem;
		border-radius: 4.5rem;
		border-color: transparent;
		caret-color: var(--c-accent);
		box-shadow: var(--box-shadow);
	}

	@media only screen and (max-width: 1024px) {
		.textarea-container:not(.expanded) {
			left: 4rem;
		}
	}
	
	@media only screen and (max-width: 870px) {
		
		.textarea-container.expanded textarea {
			width: Calc(100% + 2rem);
			margin-left: -1rem;
		}

		.textarea-container:not(.expanded) {
			width: calc(100% - 2rem);
		}
		.textarea-container:not(.expanded) textarea {
			width: 100%;
		}
	}
</style>